// extracted by mini-css-extract-plugin
export default {"pending":"CheckoutHandoffLink_pending__WV6Ue","spinner":"CheckoutHandoffLink_spinner__-3+-a"};